import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { pages } from "../data/pages";
import { CSSTransition } from "react-transition-group";
import "react-tooltip/dist/react-tooltip.css";
import "animate.css";

const NavLink = styled.a`
  border-radius: 8px;
  flex: none;
  font-weight: 500;
  padding: 2px 6px;
  text-decoration: none;
  transition: background-color 200ms ease;
`;

function Navigation() {
  const router = useLocation();

  return (
    <div className="flex items-center justify-center w-full">
      <CSSTransition timeout={1000} classNames="fade">
        <div className="fixed z-50 flex gap-2 p-3 bg-gradient-to-r from-dark-bg-800/95 to-dark-bg-900/95 rounded-2xl bottom-6 backdrop-blur-xl animate__animated animate__fadeInUp animate__delay-2s border-2 border-white/30 shadow-2xl">
          {pages.map((page, index) => (
            <NavLink
              as={Link}
              key={index}
              to={page.path}
              className="flex items-center justify-center "
            >
              <div
                className={`p-4 transition-all duration-300 hover:bg-gradient-to-r hover:from-accent-600 hover:to-purple-accent-600 hover:rounded-xl hover:shadow-glow relative tooltip ${
                  router.pathname === page.path &&
                  "bg-gradient-to-r from-accent-600 to-purple-accent-600 rounded-xl shadow-glow"
                }`}
              >
                {page.icon}
                <span className="uppercase tooltiptext">{page.title}</span>
              </div>
            </NavLink>
          ))}
        </div>
      </CSSTransition>
    </div>
  );
}

export { Navigation };
